export interface ResourceAttributes {
  [key: string]: number | string | boolean;
}

export class Resource {
  public static readonly EMPTY: Resource = new Resource({});

  /**
   * Returns an empty Resource
   */
  public static empty(): Resource {
    return Resource.EMPTY;
  }

  public constructor(
    /**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */
    readonly attributes: ResourceAttributes
  ) {}

  /**
   * Returns a new, merged {@link Resource} by merging the current Resource
   * with the other Resource. In case of a collision, current Resource takes
   * precedence.
   *
   * @param other the Resource that will be merged with this.
   * @returns the newly merged Resource.
   */
  public merge(other: Resource | null): Resource {
    if (!other || !Object.keys(other.attributes).length) {
      return this;
    }

    // Attributes from resource overwrite attributes from other resource.
    const mergedAttributes = Object.assign({}, other.attributes, this.attributes);
    return new Resource(mergedAttributes);
  }
}
